var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useEffect, useState, useCallback } from 'react';
import Draggable from 'react-draggable';
import { styled } from '@web/theme';
import { usePageEdit, useBlocks, Button } from '../../../';
export var SettingsPanel = memo(function () {
    var pageEdit = usePageEdit().pageEdit;
    var blocks = useBlocks().blocks;
    var _a = useState({ x: 0, y: 0 }), position = _a[0], setPosition = _a[1];
    var _b = useState(false), isClosed = _b[0], setIsClosed = _b[1];
    useEffect(function () {
        var positionFromLS = localStorage.getItem('@webcms:palette');
        var closedState = localStorage.getItem('@webcms:paletteClosed');
        if (positionFromLS)
            setPosition(JSON.parse(positionFromLS));
        if (closedState)
            setIsClosed(!!closedState);
    }, []);
    var toggleIsOpen = useCallback(function (e) {
        e.stopPropagation();
        var closed = !isClosed;
        if (closed)
            localStorage.setItem('@webcms:paletteClosed', "closed");
        else
            localStorage.removeItem('@webcms:paletteClosed');
        setIsClosed(closed);
    }, [isClosed]);
    var onStop = function (e, d) {
        var newPos = {
            x: d.x,
            y: d.y,
        };
        localStorage.setItem('@webcms:palette', JSON.stringify(newPos));
        setPosition(newPos);
    };
    if (!pageEdit.enabled)
        return null;
    return (React.createElement(Draggable, { bounds: "parent", handle: "strong", position: position, positionOffset: { x: '.5em', y: '.5em' }, onStop: onStop },
        React.createElement(PanelWrapper, null,
            React.createElement("strong", { className: "cursor" },
                React.createElement(PanelHeader, null,
                    React.createElement("div", null,
                        React.createElement("strong", null, "Nastaven\u00ED")),
                    React.createElement(OpenButton, { onClick: toggleIsOpen }, !isClosed ? 'Zavřít' : 'Otevřít'))),
            !isClosed &&
                React.createElement(PanelBody, null, "... :)"))));
});
var PanelWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 13px;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\n  position: absolute;\n  overflow: hidden;\n  \n  min-width: 260px;\n  max-height: 95%;\n  z-index: 990;\n"], ["\n  font-size: 13px;\n  background: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3), 0 1px 3px 1px rgba(60, 64, 67, 0.15);\n  position: absolute;\n  overflow: hidden;\n  \n  min-width: 260px;\n  max-height: 95%;\n  z-index: 990;\n"])), "#2C313C", "#f5f5f5");
var PanelHeader = styled.strong(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  width: 100%;\n  height: 32px;\n  cursor: move;\n  display: flex;\n  align-items: center;\n  padding: .3rem .7rem;\n  font-weight: 300;\n"], ["\n  background: ", ";\n  width: 100%;\n  height: 32px;\n  cursor: move;\n  display: flex;\n  align-items: center;\n  padding: .3rem .7rem;\n  font-weight: 300;\n"])), "#21252B");
var PanelBody = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\toverflow: auto;\n"], ["\n\toverflow: auto;\n"])));
var OpenButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tmargin-left: auto;\n"], ["\n\tmargin-left: auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
